import { createStyles, Theme } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { makeStyles } from '@material-ui/core/styles'
import {
  elevatedSurfaceBoxShadow,
  fullsizeAbsolute,
  transition,
} from '../../../../shared/style-settings'

const radius = 16

export const useMarketplaceListingCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: radius,
      overflow: 'hidden',
      backgroundColor: theme.palette.common.white,
      boxShadow: elevatedSurfaceBoxShadow,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    imageLink: {
      display: 'block',
      textDecoration: 'none',
      color: 'inherit',
      overflow: 'hidden',
      backgroundColor: theme.palette.grey[100],
      transition,
      '&:hover': {
        opacity: 0.98,
      },
    },
    /** `ImageCard` uses nested divs + % padding — width chain for layout. */
    imageCardHolder: {
      position: 'relative',
      width: '100%',
      minHeight: 200,
      overflow: 'hidden',
      '& div:not(.MuiCircularProgress-root):not([data-image-overlay])': {
        height: 'auto !important',
        width: '100% !important',
      },
    },
    imageFrame: {
      position: 'relative',
      width: '100%',
      minHeight: 200,
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      backgroundRepeat: 'no-repeat',
    },
    noPhoto: {
      minHeight: 200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    overlay: {
      ...fullsizeAbsolute,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: theme.spacing(1.25, 1.5, 1.5),
      pointerEvents: 'none',
      background: `linear-gradient(to top, ${fade(
        theme.palette.common.black,
        0.72
      )} 0%, ${fade(theme.palette.common.black, 0.55)} 28%, ${fade(
        theme.palette.common.black,
        0.22
      )} 62%, transparent 100%)`,
    },
    captionRow: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(0.75),
      fontSize: '0.75rem',
      lineHeight: 1.45,
      fontWeight: 600,
      color: theme.palette.common.white,
    },
    captionText: {
      flex: 1,
      minWidth: 0,
      maxHeight: 'calc(2 * 1.45 * 0.75rem)',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      wordBreak: 'break-word',
    },
    heartIcon: {
      flexShrink: 0,
      color: theme.palette.primary.light,
      fontSize: 18,
    },
    body: {
      padding: theme.spacing(2.5, 2.25, 3),
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: theme.spacing(1.5),
    },
    titleLink: {
      textDecoration: 'none',
      color: 'inherit',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    title: {
      margin: 0,
      fontSize: 'clamp(1rem, 1.2vw, 1.0625rem)',
      fontWeight: 700,
      lineHeight: 1.35,
      color: theme.palette.text.primary,
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
    price: {
      margin: 0,
      fontSize: '1.125rem',
      fontWeight: 800,
      letterSpacing: '-0.02em',
      color: theme.palette.primary.main,
    },
    /** Pushes the row’s primary action to the bottom; `Button` uses theme defaults only. */
    buyButtonSlot: {
      marginTop: 'auto',
      width: '100%',
    },
  })
)
